import Vue from 'vue';
import App from './components/app';
import trans from './trans';
import Toasted from 'vue-toasted'
import Echo from 'laravel-echo';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if (window.location.hostname != 'localhost' && window.location.hostname != '127.0.0.1' && window.location.hostname != 'deprinter.test') {
    Sentry.init({
        Vue: Vue,
        dsn: "https://7fc67d7f16eb4568882834afc131c912@o696843.ingest.sentry.io/5776446",
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
        tracingOptions: {
            trackComponents: true,
        },
    });
}

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'c33ca82e236a0504fd3e',
    wsHost: window.location.hostname,
    wsPort: 6001,
    forceTLS: false,
    disableStats: true,
});

Vue.mixin(trans);
Vue.use(Toasted, {
    theme: "toasted-primary",
    position: "bottom-right",
    duration: 5000,
    keepOnHover: true,
})

window.axios = require('axios');
window.axios.interceptors.response.use(null, function (error) {
    if (!window.axios.isCancel(error)) {
        let message = trans.methods.__('messages.went_wrong');
        if (error.response.status === 429) {
            message = trans.methods.__('messages.too_many');
        }

        if (error.response.status === 422) {
            message = trans.methods.__('messages.went_wrong');
        }

        Vue.toasted.show(message);
    }

    return Promise.reject(error);
});
window.axios.interceptors.request.use(function (request) {
    if (window.VueApp && window.VueApp.$root && window.VueApp.$root.$children && window.VueApp.$root.$children[0] && window.VueApp.$root.$children[0].session) {
        request.headers['deprintersession'] = window.VueApp.$root.$children[0].session;
    }
    return request;
}, function (error) {
    return Promise.reject(error);
});

const app = new Vue({
    el: '#app',
    components: {
        App
    }
});

window.VueApp = app;



// theme stuff
// Menu sticky
function windowScroll() {
    const navbar = document.getElementById("topnav");
    if (navbar != null) {
        if (
            document.body.scrollTop >= 50 ||
            document.documentElement.scrollTop >= 50
        ) {
            navbar.classList.add("nav-sticky");
        } else {
            navbar.classList.remove("nav-sticky");
        }
    }
}

window.addEventListener('scroll', (ev) => {
    ev.preventDefault();
    windowScroll();
})